// extracted by mini-css-extract-plugin
module.exports = {"tabs-container":"Tabs_tabs-container__323fF","tabs":"Tabs_tabs__3Gl0E","tab":"Tabs_tab__2ooKq","clicked-tab":"Tabs_clicked-tab__5V2QY","clear":"Tabs_clear__2VWO6"};